export function CloseIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M11.6,10l4.26-4.26a1.13,1.13,0,0,0-1.6-1.6L10,8.39,5.74,4.13a1.13,1.13,0,1,0-1.6,1.6L8.4,10,4.14,14.25a1.14,1.14,0,0,0,0,1.6,1.13,1.13,0,0,0,.8.35H5a1.14,1.14,0,0,0,.76-.3l.12-.14h0L10,11.59l4.26,4.26a1.13,1.13,0,0,0,1.6-1.6Z" />
    </svg>
  )
}
